export enum ChipSize {
  MD = 'md',
  LG = 'lg',
}

export enum ChipVariant {
  DEFAULT = 'default',
  AI = 'ai',
}

export const REMOVE_CHIP_KEYS = ['Delete', 'Backspace'];

export interface ChipProps {
  label: string;
  onClick?: () => void;
  isSelected?: boolean;
  size?: ChipSize;
  variant?: ChipVariant;
  icon?: string;
  isRemovable?: boolean;
  onRemove?: () => void;
  isDisabled?: boolean;
  className?: string;
  'data-testid'?: string;
}
